import * as React from "react";
import { forwardRef } from "react";
const SvgChatbot = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 3C6.5 3 2 6.58 2 11a7.77 7.77 0 0 0 2.75 5.74L3 21l4.5-2.25A11.15 11.15 0 0 0 12 19c5.5 0 10-3.58 10-8s-4.5-8-10-8m1 11H8v-2h5zm3-4H8V8h8z" }));
const ForwardRef = forwardRef(SvgChatbot);
export default ForwardRef;
